<template>
  <slide-transition>
    <div class="nuttrema-layout-east-block" :class="[ theme ? `${theme}` : '' ]">
      <slot></slot>
    </div>
  </slide-transition>
</template>

<script>
import SlideTransition from 'components/ui/transitions/slide-transition';

export default {
  name: 'nuttrema-layout-east-block',
  props: {
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    SlideTransition,
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-layout-east-block {
    display: flex;
    top: 0; left: 0;
    position: absolute;
    background-color: #fff;
    width: 100%; height: 100%;

    &.is-hidden {
      visibility: hidden;
    }

    &.is-transparent {
      background-color: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-east-block.vue